import HighlightAnimation from '../assets/styles/Highlight.module.css';

/**
 * Delay in seconds
 */
export type Delay = 'none' | 'short' | 'long';

export interface HighlightProps {
	/**
	 * @default false
	 */
	highlighted?: boolean;
	/**
	 * In seconds. Must be positive.
	 * @default 0
	 */
	highlightDelay?: Delay;
}

export const getHighlightClassName = (
	props: HighlightProps
): string | undefined => {
	const { highlighted = false, highlightDelay } = props;
	if (highlighted) {
		switch (highlightDelay) {
			case 'none':
				return HighlightAnimation.immediately;
			case 'short':
				return HighlightAnimation.shortDelay;
			case 'long':
				return HighlightAnimation.longDelay;
		}
	}
	return undefined;
};

export const DIALOG_CLASSNAME = 'dialog';
export const DIALOG_TIMEOUT = 600;
